define('plugin/location/view/LocationItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var ThemeSettings = require('lib/theme/ThemeSettings');
	
	/**
	 * Location info view (location item)
	 * 
	 * @class LocationItemView
	 */
	return LayoutView.extend({

		getTemplate: function () {
			if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
				return '#location_item_list';
			}
			return '#location_item';
		},

		serializeData: function () {
	    	var res = LayoutView.prototype.serializeData.apply(this);
			res.map_api_key = Config.getInstance().getOption('static_map_api_key');

			return res;
		}
	    
	});
	
});
